// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5565":"css/admin-app.6936","9507":"css/app.6936"}[chunkId] + ".css";
};